import axios from 'axios';
import Cookies from "js-cookie";

const userId = JSON.parse(localStorage.getItem('userInfo'))?._id; 
const api = axios.create({
    baseURL:  process.env.REACT_APP_API_BASE_URL,
    headers:{
        'Content-Type':'application/json',
        'User-Id': userId,
    },
});

const formApi = axios.create({
    baseURL:  process.env.REACT_APP_API_BASE_URL,
    headers:{
        'Content-Type':'multipart/form-data',
    },
});

const handleUnauthorized = (error) => {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        Cookies.remove('token');
        window.location.href = '/login'; 
    }
    return Promise.reject(error);
};

// Attach the interceptor to both `api` and `formApi`
api.interceptors.response.use( (response) => response, handleUnauthorized );
formApi.interceptors.response.use( (response) => response, handleUnauthorized );

// Add a request interceptor
api.interceptors.request.use(
    function (config) {
      const token = localStorage.getItem('token');
       if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
);

formApi.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem('token');
        if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export const createUser = (user) => api.post('/auth/signup',user);
export const signInUser = (user) => api.post('/auth/login', user);
export const fetchFilteredUsers = (filter) => api.get(`/dashboard/user/filter?email=${filter}`);
export const forgotPassword = (email) => api.post(`/auth/forgot-password`, email);
export const verifyCode = (code) => api.post(`/auth/verify-code`, code);
export const resetPassword = (password) => api.post(`/auth/reset-password`, password);

export const createContentType = (content) => api.post('/dashboard/content-type', content);
export const fetchContentTypes = (id) => api.get(`/dashboard/content-type/${id}`);
export const deleteContentType = (id) => api.delete(`/dashboard/content-type/${id}`);
export const editContentType = (id, content) => api.post(`dashboard/content-type/${id}`, content);

export const createWorkspace = (data) => api.post('/dashboard/workspace', data);
export const fetchWorkspaces = () => api.get('/dashboard/workspace');
export const loginWorkspace = (id) => api.get(`/dashboard/workspace/${id}`);
export const fetchWorkspaceByRole = (role) => api.get(`/dashboard/workspace/user/${role}`);
export const deleteWorkspace = (id) => api.delete(`/dashboard/workspace/${id}`);
export const updateWorkspace = (workspaceId, data) => api.put(`/dashboard/workspace/update/${workspaceId}`, data);

export const getContentType = (workspaceId, id) => api.get(`/dashboard/content-type/${workspaceId}/${id}`);
export const getEntries = (workspaceId) => api.get(`/dashboard/entries/${workspaceId}`);
export const createEntry = (entry) => api.post('/dashboard/entry',entry);
export const getEntry = (workspaceId, id) => api.get(`/dashboard/entry/${workspaceId}/${id}`);
export const updateEntry = (id, data) => api.put(`/dashboard/entry/${id}`, data);
export const deleteEntry = (id) => api.delete(`/dashboard/entry/${id}`);

export const fetchAssets = (id) => api.get(`/asset/uploads/${id}`);
export const addAsset = (data) => formApi.post('/asset/upload',data);
export const deleteAsset = (id) => api.delete(`/asset/${id}`);
export const editAsset = (id, data) => api.put(`/asset/update/${id}`, data);

export const fetchApps = () => api.get(`/app-studio/apps`);
export const createApp = (data) => api.post('/app-studio',data);
export const deleteApp = (id) => api.delete(`/app-studio/app/${id}`);
export const editApp = (id, data) => api.post(`/app-studio/${id}`, data);
export const installApp = (id, workspaceId) => api.post(`/app-studio/workspace/${workspaceId}/install/${id}`);
